/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

const baseUrl = 'academy/ai';
const pathParameterPlaceholder = undefined;
function freeze(value) {
  return Object.freeze(value);
}

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * post-/academy/ai/v1/qa
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:QAResource+type:symbol+post&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Q_A-post-%2Facademy%2Fai%2Fv1%2Fqa'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/post/api.hubapi.com%2Facademy%2Fai%2Fv1%2Fqa?showRequestDetails=true&body=%7B%22query%22:%22string%22,%22locale%22:%22string%22,%22vaasThreshold%22:null,%22vaasTopK%22:0,%22promptWhenDontKnowTheAnswer%22:%22string%22,%22debug%22:false,%22useCache%22:false,%22cacheThreshold%22:null%7D&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const callAcademyAiRpc = freeze({
  baseUrl,
  method: 'post',
  pathSegments: freeze(['v1/qa'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * post-/academy/ai/v1/vaas/query
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:VaasResource+type:symbol+post&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Vaas-post-%2Facademy%2Fai%2Fv1%2Fvaas%2Fquery'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/post/api.hubapi.com%2Facademy%2Fai%2Fv1%2Fvaas%2Fquery?showRequestDetails=true&body=%7B%22query%22:%22string%22,%22threshold%22:null,%22topK%22:0,%22portalId%22:0,%22userId%22:0%7D&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const callVaasRpc = freeze({
  baseUrl,
  method: 'post',
  pathSegments: freeze(['v1/vaas/query'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * post-/academy/ai/v1/vaas/recommendations/{language}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:RecommendationResource+type:symbol+post&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Recommendation-post-%2Facademy%2Fai%2Fv1%2Fvaas%2Frecommendations%2F%7Blanguage%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/post/api.hubapi.com%2Facademy%2Fai%2Fv1%2Fvaas%2Frecommendations%2F%28%28%7Blanguage%7D%29%29?showRequestDetails=true&body=%7B%22sourceId%22:0,%22sourceContentType%22:%22string%22,%22resultTypes%22:%5B%22string%22%5D,%22vaasThreshold%22:null,%22vaasTopK%22:0,%22numberOfResults%22:0,%22offset%22:%22string%22%7D&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getVaasRecommendationsRpc = freeze({
  baseUrl,
  method: 'post',
  pathSegments: freeze(['v1/vaas/recommendations', pathParameterPlaceholder]),
  pathParameters: freeze(['language'])
});